import apollo from '@/graphql'

import CompaniesQuery from '@/graphql/company/CompaniesQuery.gql'

// initial state
const state = {
  companies: [],
}

// getters
const getters = {
  companies: state => state.companies,
}

const mutations = {
  setCompanies(state, companies) {
    state.companies = companies
  },
}

// actions
const actions = {
  loadCompanies({ commit }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: CompaniesQuery,
    }).subscribe(({ data: { companies } }) => {
      commit('setCompanies', companies)
    })
  },
}


export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/company/CompanyList.js